/// <amd-module name="Artifacts/Root/services/FeedMessageService" />

import * as Constants from "Artifacts/Root/Constants";
import { loadData } from "Artifacts/Root/helpers/DataProviderHelpers";
import { IFeedIdentity } from "Artifacts/Root/types";
import { FeedMessage } from "Artifacts/Root/types/AzureArtifacts";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";

export interface IFeedMessageService extends IVssService {
  getFeedMessages(context: IVssPageContext, feedIdentity: IFeedIdentity): Promise<FeedMessage[]>;
}

export class FeedMessageService extends VssService implements IFeedMessageService {
  public async getFeedMessages(
    context: IVssPageContext,
    feedIdentity: IFeedIdentity,
  ): Promise<FeedMessage[]> {
    const data = await loadData<FeedMessage[]>(
      context,
      "ms.azure-artifacts.messages-data-provider",
      { feedId: feedIdentity.id, projectName: feedIdentity.project?.name },
      false,
      Constants.CommonConstants.FeedServiceInstanceId,
    );
    return Promise.resolve(data as FeedMessage[]);
  }
}

Services.add("IFeedMessageService", { serviceFactory: FeedMessageService });
